export default __webpack_public_path__ + "static/media/appointment.11655a03.png";